import React from 'react';

import { BASE_ICONS } from 'src/components/svg';
import { popupModel } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { lang, withRouter } from 'src/helpers';

import { MCButton } from 'src/components/basic';

import model from './model';

import { AddTreatment, TreatmentList } from 'src/components/user/Treatments';
import LANG_CONST from 'src/helpers/lang/const';

class Treatments extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  renderList = () => {
    return (
      <div className={'mc-setting-location mc-setting-form mc-grow'}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.titles.treatments)}</div>
          <MCButton
            primary
            light
            medium
            radius
            type={'button'}
            label={LANG_CONST.buttons.add_treatment}
            iconname={BASE_ICONS.PLUS}
            onClick={() =>
              popupModel.setActivePopup('add_profile_treatment', {
                active: true,
                component: AddTreatment,
                props: {
                  currency: model.getCurrency(),
                  onSave: model.saveData
                }
              })
            }
          />
        </div>
        <div className={'mc-container-content__body-content mc-p30 mc-grow'}>
          <TreatmentList
            treatments={model.state.treatments}
            onSave={model.saveData}
            onDel={model.del}
            currency={model.getCurrency()}
          />
        </div>
      </div>
    );
  };

  render() {
    return <div className={'mc-main-content mc-flex-col'}>{this.renderList()}</div>;
  }
}

export default withRouter(Treatments);
